import React, { useEffect } from "react";
import CommonDoctorCard from "../../../common-components/common_doctor_card/CommonDoctorCard";
import { useNavigate } from "react-router-dom";
import {
  encodeId,
  formatDate,
  formatDateTime,
  formatTime,
} from "../../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { getAllAppointment } from "../../../../features/doctor/doctorSlice";
import CommonDoctorHistoryCard from "../../../common-components/common_doctor_card/CommonDoctorHistoryCard";
import dayjs from "dayjs";
import NoData from "../../../Animation/no_data/NoData";
import CustomPaginate from "../../../common-components/CustomPaginate/CustomPaginate";
const doctorsData = [
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?q=80&w=800&auto=format&fit=crop",
    specialist: "Cardiologist",
    name: "Dr. Amit Sharma",
    hospital: "City Care Hospital, Pune",
    rating: 5,
    reviews: 25,
    price: 200,
  },
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?q=80&w=800&auto=format&fit=crop",
    specialist: "Cardiologist",
    name: "Dr. Amit Sharma",
    hospital: "City Care Hospital, Pune",
    rating: 5,
    reviews: 25,
    price: 1600,
  },
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?q=80&w=800&auto=format&fit=crop",
    specialist: "Cardiologist",
    name: "Dr. Amit Sharma",
    hospital: "City Care Hospital, Pune",
    rating: 5,
    reviews: 25,
    price: 6200,
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=800&auto=format&fit=crop",
    specialist: "Dentist",
    name: "Dr. Priya Mehta",
    hospital: "Smile Dental Clinic, Mumbai",
    rating: 4,
    reviews: 18,
    price: 500,
  },
  {
    id: 3,
    image:
      "https://images.unsplash.com/photo-1594824476967-48c8b964273f?q=80&w=800&auto=format&fit=crop",
    specialist: "Neurologist",
    name: "Dr. Raj Verma",
    hospital: "Neuro Care Hospital, Delhi",
    rating: 5,
    reviews: 40,
    price: 900,
  },
];

export default function AppointmentHistory() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const AllAppointment = useSelector((state) => state.doctor.AllAppointment);

  const fetch = async (page = 1) => {
    await dispatch(getAllAppointment({ page: page || 1 }));
  };

  useEffect(() => {
    fetch(1);
  }, [dispatch]);

  const handlePageChange = (page) => {
    fetch(page);
  };
  return (
    <div className="Personal_Info_tab">
      <div className="row">
        {AllAppointment?.data?.length > 0 ? (
          AllAppointment?.data?.map((doctor, index) => (
            <div
              className={`col-md-12 col-6 mb-3 
            ${index % 2 === 0 ? " px-md-2" : "ps-0 px-md-2"}`}
              key={doctor.id}
            >
              <CommonDoctorHistoryCard
                doctor={doctor?.Doctor}
                image={process.env.REACT_APP_IMG_URL + doctor?.Doctor?.image}
                specialist={
                  doctor?.Doctor?.Doctor_Detail?.Specialization?.name || ""
                }
                id={doctor?.Doctor?.id}
                name={`${doctor?.Doctor?.Doctor_Detail?.doctor_code ||
                  ""} ${doctor?.Doctor?.name || ""}`}
                hospital={doctor?.Doctor?.Doctor_Detail?.hospital_name || ""}
                appointmentStatus={doctor?.Appointment_Status?.name || ""}
                onDoctorClick={() =>
                  navigate(`/appointment-details/${encodeId(doctor?.id)}`)
                }
                date={dayjs(doctor?.appointment_date).format("DD MMM YYYY")}
                time={formatTime(doctor?.appointment_start)}
                appointment_no={doctor?.appointment_no || "-"}
              />
            </div>
          ))
        ) : (
          // <div
          //   style={{
          //     display: "flex",
          //     justifyContent: "center",
          //     alignItems: "center",
          //     width: "100%",
          //     minHeight: "200px",
          //   }}
          // >
          //   No Appointments Available
          // </div>
          <div className="no_product_found">
            <NoData
              text="No more appointments"
              subText="We couldn't find any appointments at the moment."
            />
          </div>
        )}
        {AllAppointment?.total_pages > 1 && (
          <CustomPaginate
            currentPage={AllAppointment?.current_page}
            totalPages={AllAppointment?.total_pages}
            handlePageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
}
